module.exports = __webpack_public_path__ + "static/media/5DPO8.ddb72c5f.jpg";